import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
      path: 'files', loadChildren: () => import('./files/files.module').then(m => m.FilesModule)
    },
    {
      path: 'manager', loadChildren: () => import('./file-manager-page/file-manager-page.module').then(m => m.FileManagerPageModule)
    },
    {
      path: 'insurances', loadChildren: () => import('./insurances/insurances.module').then(m => m.InsurancesModule)
    },
    {
      path: 'insurance-contacts', loadChildren: () => import('./insurance-contacts/insurance-contacts.module').then(m => m.InsuranceContactsModule)
    },
    {
      path: 'requests', loadChildren: () => import('./requests/requests.module').then(m => m.RequestsModule)
    },
    {
      path: 'request-types', loadChildren: () => import('./request-types/request-types.module').then(m => m.RequestTypesModule)
    },
    {
      path: 'processes', loadChildren: () => import('./processes/processes.module').then(m => m.ProcessesModule)
    },
    {
      path: 'process-types', loadChildren: () => import('./process-types/process-types.module').then(m => m.ProcessTypesModule)
    },
    {
      path: 'courts', loadChildren: () => import('./courts/courts.module').then(m => m.CourtsModule)
    },
    {
      path: 'jobs-logs', loadChildren: () => import('./jobs-logs/jobs-logs.module').then(m => m.JobsLogsModule)
    },
    {
      path: 'emails', loadChildren: () => import('./emails/emails.module').then(m => m.EmailsModule)
    },
    {
      path: '', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
    },
    {
      path: 'apps', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule)
    },
    {
      path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule)
    },
    {
      path: 'projects', loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
    },
    {
      path: 'tasks', loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule)
    },
    {
      path: 'crm', loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
    },
    {
      path: 'crypto', loadChildren: () => import('./crypto/crypto.module').then(m => m.CryptoModule)
    },
    {
      path: 'invoices', loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule)
    },
    {
      path: 'tickets', loadChildren: () => import('./tickets/tickets.module').then(m => m.TicketsModule)
    },
    {
      path: 'pages', loadChildren: () => import('./extrapages/extraspages.module').then(m => m.ExtraspagesModule)
    },
    { path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UiModule) },
    {
      path: 'advance-ui', loadChildren: () => import('./advance-ui/advance-ui.module').then(m => m.AdvanceUiModule)
    },
    {
      path: 'forms', loadChildren: () => import('./form/form.module').then(m => m.FormModule)
    },
    {
      path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule)
    },
    {
      path: 'charts', loadChildren: () => import('./charts/charts.module').then(m => m.ChartsModule)
    },
    {
      path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule)
    },
    {
      path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule)
    },
    {
      path: 'marletplace', loadChildren: () => import('./nft-marketplace/nft-marketplace.module').then(m => m.NftMarketplaceModule)
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
